import { type IOfferAnalyticsSchema } from '@/repositories/generated/shared/search-offers/entities/analytics/OfferAnalyticsSchema';
import { type IOfferForDesktopEnrichedV3Schema } from '@/repositories/generated/shared/search-offers/entities/offer_for_desktop/OfferForDesktopEnrichedV3Schema';

type GetAnalyticsProductParams = {
  offer: IOfferForDesktopEnrichedV3Schema;
};

export type AnalyticsProduct = IOfferAnalyticsSchema['product'];
export type AnalyticsProducts = Array<AnalyticsProduct>;

export function getAnalyticsProduct(params: GetAnalyticsProductParams): AnalyticsProduct {
  const { offer } = params;

  return offer.analytics.product;
}

type GetAnalyticsProductsParams = {
  offers: IOfferForDesktopEnrichedV3Schema[];
};

export function getAnalyticsProducts(params: GetAnalyticsProductsParams): AnalyticsProduct[] {
  const { offers } = params;

  return offers.map(offer => getAnalyticsProduct({ offer }));
}
